import {useRouter} from "next/router";
import {useEffect, useState} from "react";
import {putCache, withCache} from "@/base/utils/cache";


export const useComeFrom = (fallback: string | null = null, refer: string | null = null) => {
	const router = useRouter();

	const [comeFrom, setComeFrom] = useState<string | null>(fallback);

	const retryFromCache = async (code: string | null = null) => {
		return withCache(
			"come_from",
			60 * 60 * 24 * 14 * 1000,
			async () => {
				return code?.toString();
			},
			true
		).then((code) => {
			if (code)
			{
				setComeFrom(code);
			}

			return code;
		}).catch((e) => {
			setComeFrom(null);

			console.error(e)
			console.error("Failed to cache come from");
		});
	}

	const cacheComeFrom = async (code: string | null) => {
		if (code === null || code.length == 0)
		{
			return;
		}

		return putCache("come_from", code?.toString()).then(() => {
			setComeFrom(code);
		});
	}

	useEffect(() => {
		retryFromCache().then((code) => {
			if (!code)
			{
				let service: string = '';
				let type: string = '';

				if (router.query['utm_source'])
				{
					service = router.query['utm_source'].toString();

					if (router.query['utm_medium'] && ['ad'].includes(router.query['utm_medium'].toString().toLowerCase()))
					{
						type = 'ad';
					}
				}

				if (type.length == 0 && (service == 'google' || service.length == 0) && refer)
				{
					if (refer.includes('google.'))
					{
						service = 'google';
					}

					if (router.query['gclid'])
					{
						type = 'ad';
					}
				}

				let output = service;
				if (type.length > 0)
				{
					output += '_' + type;
				}
				if (output.length > 0)
				{
					console.log('[ComeFrom] Setting come from to: ', output);

					cacheComeFrom(output);
				}
			}
		});
	}, [router.query['utm_source'], router.query['utm_medium']]);

	useEffect(() => {
		retryFromCache().then((code) => {
			if (code)
			{
				console.log('[ComeFrom] Using cached come from: ', code);
			}
		});
	}, []);

	useEffect(() => {
		console.log("[ComeFrom] Come from changed to: ", comeFrom);
	}, [comeFrom]);

	const getComeFrom = () => {
		return comeFrom;
	}

	const isUsingComeFrom = () => {
		return comeFrom !== null;
	}

	return {
		getCurrentComeFrom: getComeFrom,
		isUsingComeFrom: isUsingComeFrom,
		comeFrom: comeFrom
	}
}